import http from "@/utils/http";
import {getTokenToLocalStorage} from "@/utils/token";
import {parseReadableStreamToString} from "@/services/ImageText";
// 获取资源文件夹列表
export async function getFusionmediafolderApi(params): Promise<any> {
  try {
    const res = await http.get("/api/v1/space/fusionmedia/folder", {
      params
    });
    if (res) {
      return res;
    } else {
      console.log("接口错误");
    }
  } catch (err) {
    console.log(err);
  }
}



// 获取资源模板列表
export async function fusionmediaTemplateApi(params): Promise<any> {
  try {
    const res = await http.get(`/api/v1/space/fusionmedia/template`, {
      params
    });
    if (res) {
      return res;
    } else {
      console.log("接口错误");
    }
  } catch (err) {
    console.log(err);
  }
}


// 获取特效列表
export async function getEffectApi(params): Promise<any> {
  try {
    const res = await http.get(`/api/v1/editing/effect`, {
      params
    });
    if (res) {
      return res;
    } else {
      console.log("接口错误");
    }
  } catch (err) {
    console.log(err);
  }
}


// 获取滤镜列表
export async function getFiltersApi(params): Promise<any> {
  try {
    const res = await http.get(`/api/v1/editing/filter`, {
      params
    });
    if (res) {
      return res;
    } else {
      console.log("接口错误");
    }
  } catch (err) {
    console.log(err);
  }
}


// 获取文案库列表
export async function getScriptRepoApi(params): Promise<any> {
  try {
    const res = await http.get(`/api/v1/script/repo`, {
      params
    });
    if (res) {
      return res;
    } else {
      console.log("接口错误");
    }
  } catch (err) {
    console.log(err);
  }
}

// 获取文案未使用个数
export async function getScriptRepoCountApi(params): Promise<any> {
  try {
    const res = await http.get(`/api/v1/script/repo/use/count`, {
      params
    });
    if (res) {
      return res;
    } else {
      console.log("接口错误");
    }
  } catch (err) {
    console.log(err);
  }
}

// 获取文案库详情
export async function getScriptRepoDetailsApi(params): Promise<any> {
  try {
    const res = await http.get(`/api/v1/script/repo/word`, {
      params
    });
    if (res) {
      return res;
    } else {
      console.log("接口错误");
    }
  } catch (err) {
    console.log(err);
  }
}

export async function xun_clip(params): Promise<any> {
  try {
    const res = await http.post("/api/v1/editing/timeline/xun_clip", params);
    if (res) {
      return res;
    } else {
      console.log("接口错误");
    }
  } catch (err) {
    console.log(err);
  }
}

export async function* xun_clipPreview(data): AsyncGenerator<any> {
  const token = getTokenToLocalStorage();
  const res = await fetch(`/api/v1/editing/timeline/xun_clip/preview`, {
    method: "POST",
    headers: {
      Token: `${token}`,
      "content-type": "application/json;charset=UTF-8",
      Aid: process.env.REACT_APP_AID,
    },
    body: JSON.stringify(data),
  });

  if (res.status === 400) {
    const error = await parseReadableStreamToString(res.body);
    throw new Error(error || '请求失败');
  }

  const reader = res.body?.getReader();
  if (!reader) {
    throw new Error('无法读取响应流');
  }

  const decoder = new TextDecoder();
  let buffer = '';

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      // 将二进制数据解码为字符串
      buffer += decoder.decode(value, { stream: true });

      // 按双换行符分割事件
      const events = buffer.split(/\r?\n\r?\n/);
      buffer = events.pop() || ''; // 保存不完整的事件供下一次处理

      for (const event of events) {
        if (!event.trim()) continue; // 跳过空事件

        let eventType = 'message';
        let eventData = '';

        // 解析事件类型和数据
        const lines = event.split(/\r?\n/);
        for (const line of lines) {
          if (line.startsWith('event:')) {
            eventType = line.slice(6).trim();
          } else if (line.startsWith('data:')) {
            eventData = line.slice(5).trim();
          }
        }

        if (eventData) {
          try {
            const parsedData = JSON.parse(eventData);
            // 添加事件类型到返回的数据中
            yield { event: eventType, ...parsedData };
          } catch (e) {
            console.warn('解析 JSON 失败:', e, '原始数据:', eventData);
          }
        }
      }
    }

    // 处理缓冲区中剩余的数据
    if (buffer.trim()) {
      let eventType = 'message';
      let eventData = '';

      const lines = buffer.trim().split(/\r?\n/);
      for (const line of lines) {
        if (line.startsWith('event:')) {
          eventType = line.slice(6).trim();
        } else if (line.startsWith('data:')) {
          eventData = line.slice(5).trim();
        }
      }

      if (eventData) {
        try {
          const parsedData = JSON.parse(eventData);
          yield { event: eventType, ...parsedData };
        } catch (e) {
          console.warn('解析 JSON 失败:', e, '原始数据:', eventData);
        }
      }
    }
  } catch (error) {
    console.error('处理流数据时出错:', error);
    throw error;
  } finally {
    reader.releaseLock();
  }
}
